import { render } from "./OnboardingFlowModal.vue?vue&type=template&id=5ca66850&scoped=true"
import script from "./OnboardingFlowModal.vue?vue&type=script&lang=js"
export * from "./OnboardingFlowModal.vue?vue&type=script&lang=js"

import "./OnboardingFlowModal.vue?vue&type=style&index=0&id=5ca66850&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca66850"]])

export default __exports__